import styled from 'styled-components';

import { LocaleFragment, TInsertIntlJSXPartOptions } from '@lib/tools/locale/views/LocaleFragment';

type Props = {
  text: string;
  isDevToolsEnabled: boolean;
} & TInsertIntlJSXPartOptions;

export const InsertIntlJSXPart = ({
  text,
  linkId,
  className = '',
  textId = '',
  isDevToolsEnabled,
  linkRender,
}: Props) => {
  const InsertIntlJSXPartWrapper = styled.div`
    display: inline;
    line-height: 18px;

    p {
      display: inline !important;
      margin: 0 !important;
    }
  `;

  const [initialPart = '', linkPart = '', finalPart = ''] = text ? text.split(`[linkTo=${linkId}]`) : '';

  return (
    <InsertIntlJSXPartWrapper className={className} {...(isDevToolsEnabled ? { 'data-testid': textId } : {})}>
      <LocaleFragment message={initialPart} />
      {initialPart && `${' '}`}
      {linkRender(linkPart)}
      {finalPart && `${' '}`}
      <LocaleFragment message={finalPart} />
    </InsertIntlJSXPartWrapper>
  );
};
